import {AuthRoute} from '@common/auth/guards/auth-route';
import {ActiveWorkspaceProvider} from '@common/workspace/active-workspace-id-context';
import {Navigate, RouteObject} from 'react-router';

export const driveRoutes: RouteObject[] = [
  {
    path: 'drive',
    element: (
      <ActiveWorkspaceProvider>
        <AuthRoute />
      </ActiveWorkspaceProvider>
    ),
    children: [
      {
        index: true,
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'folders/:hash',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'shares',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'recent',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'starred',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'trash',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        path: 'search',
        lazy: () => import('@app/drive/layout/drive-layout'),
      },
      {
        // sibling layout: the drive layout renders the file view directly
        // and derives its page from the pathname, so it cannot host these
        path: 'workspace',
        lazy: () => import('@app/workspace-tools/workspace-tools-layout'),
        children: [
          {index: true, element: <Navigate to="automations" replace />},
          {
            path: 'automations',
            lazy: () =>
              import('@app/workspace-tools/automations/trigger-index-page'),
          },
          {
            path: 'automations/new',
            lazy: () =>
              import('@app/workspace-tools/automations/trigger-editor-page'),
          },
          {
            path: 'automations/:id',
            lazy: () =>
              import('@app/workspace-tools/automations/trigger-editor-page'),
          },
          {
            path: 'automations/:id/runs',
            lazy: () =>
              import('@app/workspace-tools/automations/trigger-runs-page'),
          },
          {
            path: 'custom-fields',
            lazy: () =>
              import(
                '@app/workspace-tools/custom-fields/custom-field-index-page'
              ),
          },
          {
            path: 'invitations',
            lazy: () =>
              import('@app/workspace-tools/invitations/invitations-page'),
          },
          {
            path: 'invitations/activity',
            lazy: () =>
              import(
                '@app/workspace-tools/invitations/invitations-activity-page'
              ),
          },
        ],
      },
    ],
  },
  {
    path: 'drive/s/:hash',
    lazy: () =>
      import(
        '@app/drive/shareable-link/shareable-link-page/shareable-link-page'
      ),
  },
  {
    path: 'k/:hash',
    lazy: () =>
      import(
        '@app/drive/shareable-link/shareable-link-page/shareable-link-page'
      ),
  },
];
